export default "__VITE_ASSET__CBC_I9sV__"